export const SITE_NAME = "КЦ Авто"
export const SITE_ORIGIN = (import.meta.env.VITE_SITE_URL || "https://kcsib.ru").replace(/\/+$/, "")
export const DEFAULT_OG_IMAGE_PATH = "/android-chrome-512x512.png"

export const toAbsoluteSiteUrl = (pathOrUrl: string) => {
  if (/^https?:\/\//i.test(pathOrUrl)) return pathOrUrl
  return new URL(pathOrUrl.startsWith("/") ? pathOrUrl : `/${pathOrUrl}`, `${SITE_ORIGIN}/`).toString()
}
